module.exports = __webpack_public_path__ + "img/9788991503182.798a9dbd.jpg";